import React, { PropTypes } from "react";
import Loadable from "../../react-loadable";
import List from "./ListAsync";
import Operation from "./OperationAsync";
import Search from "./SearchAsync";

const Transfer_browser = Loadable({
  loader: () => import("./TransferBrowser"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

Transfer_browser.List = List;
Transfer_browser.Operation = Operation;
Transfer_browser.Search = Search;
export default Transfer_browser;



// WEBPACK FOOTER //
// ./_antd1.11.2/transfer_browser/index.jsx